
import {get_file} from 'stores/files'
import Rest from 'utils/rest'


export default {
  props: {
    file: {
      type: Object,
      required: true
    },
  },
  emits: ['delete', 'download', 'edit'],
  data() {
    return {
      text: undefined
    }
  },
  async mounted() {
    const rest = new Rest({auth: false, json: false})
    const file = await get_file(this.file.id)
    try {
      this.text = await rest.get(file.url)
    }
    catch(ex) {
      console.error(ex)
      this.text = 'Error: failed to get file contents'
    }
  }
}
